import React, { useState, useEffect, useRef } from "react";
import { Form, Button, Alert, Modal } from "react-bootstrap";
import { useAuth } from "../contexts/AuthContext";
import "./style/Profile.css";
import {
  confirmPasswordReset,
  getAuth,
  updatePassword,
  reauthenticateWithCredential,
  EmailAuthProvider,
} from "firebase/auth";
import { db } from "../firebase";
import { doc, updateDoc, getDoc } from "firebase/firestore";
import LogoIcon from "./assets/img/logo-main.png";

export default function Profile() {
  const [currentUserDetails, setCurrentUserDetails] = useState();
  const [currentUserStored, setCurrentUserStored] = useState();
  const nameRef = useRef();
  const emailRef = useRef();
  const contactRef = useRef();
  const passwordRef = useRef();
  const passwordConfirmRef = useRef();
  const currentPasswordRef = useRef();
  const addressRef = useRef();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [name, setName] = useState("");
  const [contact, setContact] = useState("");
  let isResetPassword = false;
  const { currentUser } = useAuth();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [editable, setEditable] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [showPasswordFields, setShowPasswordFields] = useState(false);
  document.title ='Profile - Hentian Komuniti';

  async function handleEdit(e) {
    setError("");
    e.preventDefault();
    if (!nameRef.current.value) {
      setLoading(false);
      return setError("Name should not be empty");
    }

    if (!contactRef.current.value) {
      setLoading(false);
      return setError("Contact should not be empty");
    }

    if (!validateContactNumber(contactRef.current.value)) {
      setError("Contact number must be at least 8 digits");
      setLoading(false);
      return;
    }

    if (
      passwordRef.current.value ||
      passwordConfirmRef.current.value ||
      currentPasswordRef.current.value
    ) {
      isResetPassword = true;
      if (!passwordRef.current.value) {
        setLoading(false);
        return setError("Password should not be empty");
      }
      if (!passwordConfirmRef.current.value) {
        setLoading(false);
        return setError("Confirm Password should not be empty");
      }
      if (!currentPasswordRef.current.value) {
        setLoading(false);
        return setError("Current Password should not be empty");
      }

      if (
        passwordRef.current.value.length < 6 ||
        passwordConfirmRef.current.value.length < 6
      ) {
        setLoading(false);
        return setError("Passwords must longer than 6 character");
      }

      if (passwordRef.current.value !== passwordConfirmRef.current.value) {
        setLoading(false);
        return setError("Passwords do not match");
      }
    } else {
      isResetPassword = false;
    }

    if (isResetPassword) {
      if (
        !(await changePassword(
          currentPasswordRef.current.value,
          passwordConfirmRef.current.value
        ))
      ) {
        setLoading(false);
        return setError(
          "Error in changing password and profile, please try again"
        );
      } else {
        if (
          !(await updateProfile(
            nameRef.current.value,
            contactRef.current.value
          ))
        ) {
          setLoading(false);
          return setError("Error in updating profile, please try again");
        }
      }
    } else {
      if (
        !(await updateProfile(nameRef.current.value, contactRef.current.value))
      ) {
        setLoading(false);
        return setError("Error in updating profile, please try again");
      }
    }
    setLoading(false);
    setShowSuccessModal(true);
    resetUserDetails();
    setEditable(false);
    setShowPasswordFields(false);
    setCurrentPassword("");
    setPassword("");
    setPasswordConfirm("");
  }

  const changePassword = async (currentPassword, newPassword) => {
    try {
      const auth = getAuth();
      const credentials = EmailAuthProvider.credential(
        currentUser.email,
        currentPassword
      );
      console.log("User credentials", credentials);
      // Reauthenticate the user to verify the current password
      await reauthenticateWithCredential(currentUser, credentials);
      // Update the password
      await updatePassword(currentUser, newPassword);
      console.log("Password changed successfully!");

      return true;
    } catch (error) {
      console.error("Error changing password:", error);
      return false;
      // Handle error: For example, display an error message to the user
    }
  };

  const updateProfile = async (name, contact) => {
    console.log("User name and contact", name, contact);
    try {
      console.log(currentUserStored.uid);
      const userRef = doc(db, "merchants", currentUserStored.uid);
      await updateDoc(userRef, {
        name: name,
        contact: contact,
      });
      console.log("Update Profile successfully!");

      return true;
    } catch (error) {
      console.error("Error updating profile:", error);
      return false;
      // Handle error: For example, display an error message to the user
    }
  };

  function validateContactNumber(contact) {
    // Regular expression to match a number with a minimum length of 8 digits
    const contactRegex = /^\d{8,}$/;
    return contactRegex.test(contact);
  }

  useEffect(() => {
    const storedUser = sessionStorage.getItem("currentUserDetail");
    if (storedUser) {
      if (!currentUserDetails) {
        setCurrentUserDetails(JSON.parse(storedUser));
        setName(JSON.parse(storedUser).name);
        setContact(JSON.parse(storedUser).contact);
      }
    } else {
      console.log("No user found in session storage");
    }
  }, [currentUserDetails, setCurrentUserDetails]);

  useEffect(() => {
    const user = sessionStorage.getItem("currentUser");
    if (user) {
      if (!currentUserStored) {
        setCurrentUserStored(JSON.parse(user));
      }
    } else {
      console.log("No user found in session storage");
    }
  }, [currentUserStored, setCurrentUserStored]);

  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const resetUserDetails = async () => {
    const docRef = doc(db, "merchants", currentUser.uid);
    const docSnap = await getDoc(docRef);
    const userDetail = JSON.stringify(docSnap.data());
    sessionStorage.setItem("currentUserDetail", userDetail);
  };

  const handleEditMode = () => {
    setEditable(true);
  };
  const handleCancelEdit = () => {
    setEditable(false);
    setName(currentUserDetails.name);
    setContact(currentUserDetails.contact);
    setCurrentPassword("");
    setPassword("");
    setPasswordConfirm("");
    setShowPasswordFields(false);
  };

  const handleCheckboxChange = (e) => {
    setShowPasswordFields(e.target.checked);
  };

  return (
    <div className="col-12">
      <div className="mt-2 ms-4">
        <h3 className="company-name">
          <span className="">
            <img src={LogoIcon} className="me-2 logo-merchant"></img>
          </span>
          {currentUserDetails && currentUserDetails.name}
        </h3>
      </div>
      <hr id="line" className="text-secondary"></hr>

      <div className="mx-3">
        <Form className="custom-form" onSubmit={handleEdit}>
          <Form.Group className="mt-1" id="name">
            <Form.Label className="custom-label mb-0">Name</Form.Label>
            <Form.Control
              className="custom-input"
              type="text"
              ref={nameRef}
              value={name && name}
              onChange={(e) => setName(e.target.value)}
              disabled={!editable}
            />
          </Form.Group>

          <Form.Group className="mt-1" id="email">
            <Form.Label className="custom-label mb-0">Email</Form.Label>
            <Form.Control
              className="custom-input"
              type="email"
              ref={emailRef}
              value={currentUserStored && currentUserStored.email}
              disabled={true}
            />
          </Form.Group>

          <Form.Group className="mt-1" id="contact">
            <Form.Label className="custom-label mb-0">Contact</Form.Label>
            <Form.Control
              className="custom-input"
              type="tel"
              ref={contactRef}
              value={contact && contact}
              onChange={(e) => setContact(e.target.value)}
              disabled={!editable}
            />
          </Form.Group>

          <Form.Group className="mt-1" id="address">
            <Form.Label className="custom-label mb-0">Address</Form.Label>
            <Form.Control
              className="custom-input"
              type="text"
              as="textarea"
              rows={5}
              ref={addressRef}
              value={currentUserDetails && currentUserDetails.address}
              disabled={true}
            />
          </Form.Group>

          <Form.Group className="mt-2" controlId="showPasswordCheckbox">
            <Form.Check
              type="checkbox"
              label="Change Password"
              onChange={handleCheckboxChange}
              disabled={!editable}
            />
          </Form.Group>
          {showPasswordFields && (
            <div>
              <Form.Group className="mt-1" id="password">
                <Form.Label className="custom-label mb-0">
                  Current Password
                </Form.Label>
                <Form.Control
                  className="custom-input"
                  type="password"
                  ref={currentPasswordRef}
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  disabled={!editable}
                />
              </Form.Group>

              <Form.Group className="mt-1" id="password">
                <Form.Label className="custom-label mb-0">Password</Form.Label>
                <Form.Control
                  className="custom-input"
                  type="password"
                  ref={passwordRef}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={!editable}
                />
              </Form.Group>

              <Form.Group className="mt-1" id="password-confirm">
                <Form.Label className="custom-label mb-0">
                  Confirm Password
                </Form.Label>
                <Form.Control
                  className="custom-input"
                  type="password"
                  ref={passwordConfirmRef}
                  value={passwordConfirm}
                  onChange={(e) => setPasswordConfirm(e.target.value)}
                  disabled={!editable}
                />
              </Form.Group>
            </div>
          )}

          {error && <Alert variant="danger mt-2">{error}</Alert>}

          {!editable && (
            <div className="d-flex justify-content-end">
              <Button className="mt-4" id="customBtn" onClick={handleEditMode}>
                Edit
              </Button>{" "}
            </div>
          )}
          {editable && (
            <div className="d-flex justify-content-between">
              <Button
                className="mt-4"
                id="cancelBtn"
                disabled={loading}
                onClick={handleCancelEdit}
              >
                Cancel
              </Button>

              <Button
                className="mt-4"
                id="customBtn"
                disabled={loading}
                type="submit"
              >
                Save
              </Button>
            </div>
          )}
        </Form>
      </div>
      <Modal show={showSuccessModal} onHide={handleCloseSuccessModal}>
        <Modal.Header closeButton>
          <Modal.Title>Success!</Modal.Title>
        </Modal.Header>
        <Modal.Body>Your profile has been successfully updated.</Modal.Body>
        <Modal.Footer>
          <Button id="customBtn" onClick={handleCloseSuccessModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
